export const scheduleCall = () => {
    return {
        url: 'core/v4/support/schedulecall',
        method: 'get',
    };
};
